<ion-content>
  <div class="verify-code-area">
    <div class="header-titles">
      <div class="btn-return-b">
        <button class="return-btn" (click)="backto()"></button>
        <h1>{{ 'VERIFY_CODE_PAGE.TITLE' | translate }}</h1>
      </div>

      <h3 class="blue-sky">{{"VERIFY_CODE_PAGE.SUBTITLE"|translate}}</h3>
    </div>
    <div class="code-input-container">
      <code-input
        [isCodeHidden]="false"
        [codeLength]="6"
        (codeChanged)="onCodeChanged($event)"
        (codeCompleted)="onCodeCompleted($event)"
      >
      </code-input>
      <div class="error-message" *ngIf="submitted && !validCode">
        {{errorMessage}}
      </div>
    </div>
  </div>
  <div class="footer">
    <!-- <button [disabled]="!validCode" class="send-btn" (click)="submitForm()">
      <span> {{'BUTTONS.SEND' | translate}} </span>
    </button> -->
    <app-button
      [innerText]="'BUTTONS.SAVE' | translate"
      [disabled]="isLoading || isLoading"
      [loading]="isLoading "
      (onClick)="submitForm()"
    ></app-button>
    <div class="t-group">
      {{'VERIFY_CODE_PAGE.TITLE_CODES.NO_RECEIVE' | translate}}
      <button (click)="resendCode()" class="blue-sky resend-btn">
        {{'VERIFY_CODE_PAGE.TITLE_CODES.RESEND' | translate}}
      </button>
    </div>
  </div>
</ion-content>
